

export const lowercaseregex = /(?=.*[a-z]{0})/
export const UpperCaseRegex = /(?=.*[A-Z]){1}/
export const numberRegex = /(?=.*[0-9]){0}/
export const specialCharacterRegex = /(?=.*[!@#$%^&*]){0}/